import {useEffect} from 'react'

import {getServerInfo} from '../../data/serverInfo.js'

export default function ListenToServerInfo() {
  useEffect(() => {
    let timeout

    function listen() {
      getServerInfo()

      timeout = setTimeout(listen, 60000)
    }

    listen()

    return () => clearTimeout(timeout)
  }, [])

  return null
}
